var _style, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowPepper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#325CA7;}\n\t.st1{fill:#EFC05D;}\n\t.st2{fill:#74B757;}\n\t.st3{fill:none;stroke:#D6961F;stroke-width:3;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.63,182.83c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C29.33,148.54,63.94,182.83,106.63,182.83"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M145.59,100.45c-0.33-3.99-0.78-8.07-2.67-11.58c-2.55-4.68-7.53-7.8-12.81-8.76 c-1.89-0.33-3.84-0.42-5.76-0.27c-1.83-2.76-5.07-4.41-8.25-5.64c-1.38-0.54-2.88-1.02-4.35-0.75c-0.08,0.33-0.07,0.67-0.11,1.01 c-1.55-0.54-3.28-0.85-5.22-0.85c-0.8,0-1.55,0.07-2.28,0.17c0.01-0.23,0.02-0.46,0.02-0.69l-0.24-0.03 c-2.91,0.36-5.85,0.87-8.52,2.13c-2.64,1.23-5.04,3.27-6.18,5.97l0.81,0.51c-5.16-0.27-10.38,0.3-14.61,3.12 c-5.16,3.39-7.92,9.57-8.55,15.69c-0.6,6.12,0.72,12.27,2.25,18.24c1.59,6.24,3.54,12.6,7.62,17.58c4.08,4.98,10.74,8.37,16.98,6.81 l0.6-0.6c3.87,3.87,9.51,6.24,14.73,4.83c3.75-0.99,6.57-3.54,8.79-6.75l0.15,0.27c1.44,3.18,5.31,4.8,8.76,4.38 c3.48-0.45,6.54-2.52,8.97-5.01c4.95-5.04,7.86-11.79,9.21-18.72C146.25,114.61,146.1,107.47,145.59,100.45z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M118.41,61.51c-0.42,2.73-0.69,5.49-0.78,8.25c-1.89-0.78-4.2,0.33-5.25,2.1c-0.3,0.48-0.51,1.02-0.63,1.59 c-0.36,1.41-0.27,2.94,0.03,4.38c0.48,2.31,1.53,4.5,3,6.33l-0.36,0.69c-1.71-0.45-3.45-0.69-5.19-0.72 c-1.89-0.06-3.78,0.09-5.64,0.42c-1.71-0.87-6.73,2.15-8.62,1.79L99.22,82c2.04-1.05,3.05-2.34,4.1-4.38 c0.72-1.38,0.84-2.94,0.84-4.53c-0.03-1.47-0.12-3,0.09-4.47c0.45-3.03,2.49-5.82,5.25-7.23C112.26,60.01,115.68,60.04,118.41,61.51 z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M90.95,88.82c5.74-2.7,11.92-4.86,18.26-4.7s12.89,3.01,16.17,8.44c1.69,2.8,2.43,6.08,2.79,9.33 c0.45,4.03,0.36,8.11-0.26,12.11c-0.94,6.06-3.07,11.86-5.38,17.54c-2.71,6.66-6.53,13.96-13.48,15.8 c-5.72,1.52-11.92-1.41-15.77-5.91s-5.78-10.31-7.27-16.04c-1.59-6.09-2.81-12.38-2.24-18.65"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowPepper);
export default __webpack_public_path__ + "static/media/Yellow_pepper.5e427acf6791b6841b21cb4e58d37692.svg";
export { ForwardRef as ReactComponent };